module.exports = __webpack_public_path__ + "static/img/che.46d8b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che.png
// module id = R14B
// module chunks = 0